import React from 'react';


const SessionLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen w-full bg-(--neutral-50)">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-(--color-primary)"></div>
    </div>
  );
}

export default SessionLoading;